import './App.css';
import Application from './Application.js'

function App() {

  return (
    <div className="App">
      <Application />
    </div>
  );
}

export default App;
